import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  preBuiltTemplatesMapping: [],
  preBuiltTemplatesLoading: false,
  allTemplates: [],
};

const preBuiltTemplatesSlice = createSlice({
  name: 'preBuiltTemplatesSlice',
  initialState,
  reducers: {
    preBuiltTemplatesMappingSlice: (state, { payload }) => {
      state.preBuiltTemplatesMapping = payload;
    },
    preBuiltTemplatesLoadingSlice: (state, { payload }) => {
      state.preBuiltTemplatesLoading = payload;
    },
    allTemplatesSlice: (state, { payload }) => {
      state.allTemplates = payload;
    },
  },
});

const { actions, reducer } = preBuiltTemplatesSlice;

export const {
  preBuiltTemplatesMappingSlice,
  preBuiltTemplatesLoadingSlice,
  allTemplatesSlice,
} = actions;

export default reducer;
